/// <reference path="./ts-declarations/expo-router-internal-globals.ts" />
/// <reference path="./ts-declarations/expo-router-internal.d.ts" />
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

//# sourceMappingURL=global.js.map
